import React, { Fragment } from 'react';
import { useParams } from 'react-router-dom';
import HeaderMenu from '../components/menu/header_container';
import DynamicComponent from '../middleware/dynamic_component';
import DynamicMenu from '../components/menu/dynamic_menu';

function ElecDocumentPage() {
  const { module } = useParams();
  return (
    <Fragment>
      <HeaderMenu>
        <DynamicMenu section={3} />
      </HeaderMenu>
      {module && <DynamicComponent componentName={module} />}
    </Fragment>
  );
}

export default ElecDocumentPage;


// WEBPACK FOOTER //
// ./src/pages/electronic_documents.jsx